// Copyright (c) 2016 Deere & Company

import DateCellRenderer from '../../shared/report-cell-renderers/date-cell-renderer';
import PinCellRenderer from '../../shared/report-cell-renderers/pin-cell-renderer';
import classNames from '../../shared/constants/ag-grid-class-names';
import dateFilterParams from '../../shared/constants/date-filter-params';
import {translate} from '../../../shared/services/translation-service';

export function getMaintenancePlanColumnDefinitions() {

    return [
        {
            cellClass: classNames.cellLeftClassName,
            cellRendererFramework: PinCellRenderer,
            colId: 'pin',
            field: 'pin',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('PIN'),
            width: 190
        },
        {
            cellClass: classNames.cellClassName,
            colId: 'contractNumber',
            field: 'contractNumber',
            headerClass: classNames.headerClassName,
            headerName: translate('CONTRACT_NUMBER'),
            width: 200
        },
        {
            cellClass: classNames.cellClassName,
            colId: 'responsibleDealer',
            field: 'responsibleDealer',
            headerClass: classNames.headerClassName,
            headerName: translate('ACCOUNT'),
            width: 100
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'dealerName',
            field: 'dealerName',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('DEALER'),
            width: 200
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'dealerCity',
            field: 'dealerCity',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('LOCATION'),
            width: 200
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'customerName',
            field: 'customerName',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('CUSTOMER_NAME'),
            width: 200
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'planName',
            field: 'planName',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('PLAN_NAME'),
            width: 130
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'planDescription',
            field: 'planDescription',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('PLAN_DESCRIPTION'),
            width: 160
        },
        {
            cellClass: classNames.cellRightClassName,
            colId: 'serviceIntervalNumber',
            field: 'serviceIntervalNumber',
            headerClass: classNames.headerRightClassName,
            headerName: translate('SERVICE_INTERVAL_NUMBER'),
            width: 240
        },
        {
            cellClass: classNames.cellClassName,
            colId: 'serviceIntervalType',
            field: 'serviceIntervalType',
            headerClass: classNames.headerClassName,
            headerName: translate('SERVICE_INTERVAL_TYPE'),
            width: 240
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'intervalTypeDescription',
            field: 'intervalTypeDescription',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('INTERVAL_TYPE_DESCRIPTION'),
            width: 260
        },
        {
            cellClass: classNames.cellClassName,
            cellRendererFramework: DateCellRenderer,
            colId: 'intervalBeginDate',
            field: 'intervalBeginDate',
            filter: 'date',
            filterParams: dateFilterParams,
            headerClass: classNames.headerClassName,
            headerName: translate('INTERVAL_BEGINS'),
            width: 160
        },
        {
            cellClass: classNames.cellClassName,
            cellRendererFramework: DateCellRenderer,
            colId: 'intervalEndDate',
            field: 'intervalEndDate',
            filter: 'date',
            filterParams: dateFilterParams,
            headerClass: classNames.headerClassName,
            headerName: translate('INTERVAL_ENDS'),
            width: 160
        },
        {
            cellClass: classNames.cellClassName,
            cellRendererFramework: DateCellRenderer,
            colId: 'completionDate',
            field: 'completionDate',
            filter: 'date',
            filterParams: dateFilterParams,
            headerClass: classNames.headerClassName,
            headerName: translate('COMPLETED'),
            width: 140
        },
        {
            cellClass: classNames.cellRightClassName,
            colId: 'hoursLimit',
            field: 'hoursLimit',
            filter: 'number',
            headerClass: classNames.headerRightClassName,
            headerName: translate('HOUR_LIMIT'),
            width: 120
        },
        {
            cellClass: classNames.cellRightClassName,
            colId: 'actualHours',
            field: 'actualHours',
            filter: 'number',
            headerClass: classNames.headerRightClassName,
            headerName: translate('ACTUAL_HOURS'),
            width: 140
        },
        {
            cellClass: classNames.cellClassName,
            colId: 'serviceIntervalStatus',
            field: 'serviceIntervalStatus',
            headerClass: classNames.headerClassName,
            headerName: translate('SERVICE_INTERVAL_STATUS'),
            width: 200
        },
        {
            cellClass: classNames.cellClassName,
            colId: 'statusDescription',
            field: 'statusDescription',
            headerClass: classNames.headerClassName,
            headerName: translate('STATUS'),
            width: 100
        },
        {
            cellClass: classNames.cellClassName,
            colId: 'model',
            field: 'model',
            headerClass: classNames.headerClassName,
            headerName: translate('MODEL'),
            width: 100
        },
        {
            cellClass: classNames.cellClassName,
            cellRendererFramework: DateCellRenderer,
            colId: 'planStartDate',
            field: 'planStartDate',
            filter: 'date',
            filterParams: dateFilterParams,
            headerClass: classNames.headerClassName,
            headerName: translate('PLAN_STARTS'),
            width: 130
        },
        {
            cellClass: classNames.cellClassName,
            cellRendererFramework: DateCellRenderer,
            colId: 'planEndDate',
            field: 'planEndDate',
            filter: 'date',
            filterParams: dateFilterParams,
            headerClass: classNames.headerClassName,
            headerName: translate('PLAN_ENDS'),
            width: 120
        }
    ];

}



// WEBPACK FOOTER //
// ./src/reports/maintenance-plan/report-services/column-definitions.js